import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import { stat } from 'fs';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    getters: {
        isLoggedIn: state => {
            return state.user.username.length > 0
        },
        hasPerm: state => perm => {
            if (perm == undefined || perm == "") return true
            return state.user.permissions.some(v => {
                return v == perm
            })
        }
    },
    modules: {
        user: user
    },
    strict: false,
    // plugins: debug ? [createLogger()] : []
})
